<template>
  <div class="header">
    <div class="collapse-btn" @click="collapseChange">
      <i v-if="!isCollapse" class="el-icon-s-fold"></i>
      <i v-else class="el-icon-s-unfold"></i>
    </div>
    <div class="logo">DESK TOOL</div>
    <div class="header-right">
      <div class="header-user-con">
        <!--首页-->
        <!--<div style="margin-right: 1rem;font-size: 1.45rem;">
            <el-tooltip effect="dark" content="首页" placement="bottom">
                <router-link to="/">
                    <i class="el-icon-s-home" style="color:#fff"></i>
                </router-link>
            </el-tooltip>

        </div>-->
        <!-- 全屏显示 -->
        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>
        <!-- 刷新权限 -->
        <div class="btn-refresh" @click="handleRefreshPermissions">
          <el-tooltip effect="dark" content="刷新权限" placement="bottom">
            <i class="el-icon-refresh"></i>
          </el-tooltip>
        </div>
        <!-- 消息中心 -->
        <!--<div class="btn-bell">
            <el-tooltip
                    effect="dark"
                    :content="message?`有${message}条未读消息`:`消息中心`"
                    placement="bottom"
            >
                <router-link to="/tabs">
                    <i class="el-icon-bell"></i>
                </router-link>
            </el-tooltip>
            <span class="btn-bell-badge" v-if="message"></span>
        </div>-->
        <!-- 用户头像 -->
        <div class="user-avator">
          <!--<img src="@/assets/img/img.jpg"/>-->
          <i class="el-icon-user"></i>
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ username }}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
          <el-dropdown-menu slot="dropdown">
            <a href="" target="_blank">
              <el-dropdown-item>个人资料</el-dropdown-item>
            </a>
            <el-dropdown-item command="changepass">修改密码</el-dropdown-item>
            <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown class="user-name" trigger="click" @command="handleLanguage">
                    <span class="el-dropdown-link">
                          {{ $t("navbar.language") }}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh">中文</el-dropdown-item>
            <el-dropdown-item divided command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

export default {
  name: "Header",
  data() {
    return {
      fullscreen: false,
      message: 2
    };
  },
  computed: {
    ...mapState(['isCollapse', 'user_info']),
    // 获取当前登录用户名
    username() {
      return this.user_info?.username || this.user_info?.name || '未登录';
    }
  },
  methods: {
    ...mapMutations(['changeCollapse', 'setLogout', 'minCollapse']),
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == 'loginout') {
        // 调用后端退出登录接口
        const refreshToken = localStorage.getItem('refresh_token');
        this.http.fetchPost(this.api.logout, { refresh_token: refreshToken }).then((res) => {
          console.log(res.data)
          if (res.data.code === 200) {
            this.$message.success('退出登录成功');
            this.setLogout();
            this.$router.push('/login');
          } else {
            this.$message.error('退出登录失败');
            // 即使后端失败，也清除本地token
            this.setLogout();
            this.$router.push('/login');
          }
        }).catch(err => {
          console.log(err)
          // 网络错误时也清除本地token
          this.setLogout();
          this.$router.push('/login');
        })
      } else if (command == 'changepass') {
        this.$router.push('/chanpass');
      }
    },
    //切换语言
    handleLanguage(command) {
      if (command === 'en') {
        this.$i18n.locale = 'en'
        localStorage.setItem('language', 'en')
      } else if (command === 'zh') {
        this.$i18n.locale = 'zh'
        localStorage.setItem('language', 'zh')
      }
    },
    // 侧边栏折叠
    collapseChange() {
      this.changeCollapse()
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    // 刷新权限
    handleRefreshPermissions() {
      this.$store.dispatch('refreshUserPermissions')
        .then(() => {
          this.$message.success('权限已更新');
        })
        .catch(() => {
          this.$message.error('刷新失败');
        });
    }
  },
  mounted() {
    if (document.body.clientWidth < 1000) {
      this.minCollapse();
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/css/varibles.styl"
.header
  position: relative
  box-sizing: border-box
  width 100%
  height $hdHeight
  font-size 1.375rem
  color #fff

.collapse-btn
  width 1.5rem
  float left
  padding 0 1.25rem
  cursor pointer
  line-height $hdHeight

.header .logo
  float left
  width 15.625rem
  line-height $hdHeight

.header-right
  float right
  padding-right 3.125rem

.header-user-con
  display flex
  height $hdHeight
  align-items center


.btn-fullscreen
  transform rotate(45deg)
  font-size 1.5rem

.btn-refresh
  font-size 1.5rem
  margin-left 1rem

.btn-bell, .btn-fullscreen, .btn-refresh
  position relative
  text-align center
  border-radius 1rem
  cursor pointer

.btn-bell
  margin-left 1rem

  .btn-bell-badge
    position absolute
    right -.31rem
    top 1rem
    width .5rem
    height .5rem
    border-radius .25rem
    background #f56c6c
    color #fff

.btn-bell .el-icon-bell
  color #fff

.user-name
  margin-left .625rem

.user-avator
  margin-left: 1.25rem

  img
    display block
    width 2.5rem
    height 2.5rem
    border-radius 50%

.el-dropdown-link
  color #fff
  cursor pointer

.el-dropdown-menu__item
  text-align center
  font-size .875rem

</style>
